import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
    getClassification,
    payloadToObject
} from "../Components/notificationMonitorUtils";

function NotificationDetailsDrawer({
    item,
    guide,
    onClose,
    onUpdateStatus
}) {
    const [payloadView, setPayloadView] = useState("json");

    if (!item) {
        return null;
    }

    const classification = getClassification(item.type, guide);
    const payloadObj = payloadToObject(item.payload);
    const entries = Object.entries(payloadObj);

    return (
        <>
            <div
                className="anm-drawer-backdrop"
                onClick={onClose}
            />

            <div className="anm-drawer">

                {/* Header */}
                <div className="anm-drawer-header">
                    <h3>Notification Details</h3>

                    <button
                        type="button"
                        className="anm-close-btn"
                        onClick={onClose}
                    >
                        <i className="fas fa-times" />
                    </button>
                </div>

                {/* Body */}
                <div className="anm-drawer-body">

                    {/* Store */}
                    <Row className="anm-detail-group">
                        <Col md={12}>
                            <div className="anm-detail-label">
                                Store
                            </div>

                            <div className="anm-detail-value">
                                {item.store || "-"}
                            </div>
                        </Col>
                    </Row>

                    {/* Seller / ASIN / SKU */}
                    <Row className="anm-detail-group">

                        <Col md={4}>
                            <div className="anm-detail-label">
                                Seller ID
                            </div>

                            <div className="anm-detail-value anm-monospace">
                                {item.sellerId || "N/A"}
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="anm-detail-label">
                                ASIN
                            </div>

                            <div className="anm-detail-value">
                                {item.asin || "N/A"}
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="anm-detail-label">
                                SKU
                            </div>

                            <div className="anm-detail-value">
                                {item.sku || "N/A"}
                            </div>
                        </Col>

                    </Row>

                    {/* Notification Type */}
                    <Row className="anm-detail-group">
                        <Col md={12}>

                            <div className="anm-detail-label">
                                Notification Type
                            </div>

                            <div className="anm-detail-value anm-primary-text">
                                {item.type || "-"}
                            </div>

                        </Col>
                    </Row>

                    {/* Classification */}
                    <Row className="anm-detail-group">
                        <Col md={12}>

                            <div className="anm-detail-label">
                                Classification Rule
                            </div>

                            <div className="anm-detail-value">

                                Severity:{" "}
                                <strong>
                                    {classification.severity}
                                </strong>

                                {" | "}

                                Impact:{" "}
                                <strong>
                                    {classification.businessImpact}
                                </strong>

                                {" | "}

                                Attention:{" "}
                                <strong>
                                    {classification.needsAttention}
                                </strong>

                            </div>

                        </Col>
                    </Row>

                    {/* Payload */}
                    <Row className="anm-detail-group">
                        <Col md={12}>

                            <div className="d-flex justify-content-between align-items-center mb-2">

                                <div className="anm-detail-label mb-0">
                                    Notification Payload
                                </div>

                                <div className="anm-toggle-group">

                                    <button
                                        type="button"
                                        className={
                                            "anm-action-btn" +
                                            (
                                                payloadView === "json"
                                                    ? " active-toggle"
                                                    : ""
                                            )
                                        }
                                        onClick={() =>
                                            setPayloadView("json")
                                        }
                                    >
                                        JSON
                                    </button>

                                    <button
                                        type="button"
                                        className={
                                            "anm-action-btn" +
                                            (
                                                payloadView === "data"
                                                    ? " active-toggle"
                                                    : ""
                                            )
                                        }
                                        onClick={() =>
                                            setPayloadView("data")
                                        }
                                    >
                                        Data View
                                    </button>

                                </div>

                            </div>

                            {payloadView === "json" ? (

                                <pre className="anm-payload-pre">
                                    {JSON.stringify(
                                        payloadObj,
                                        null,
                                        2
                                    )}
                                </pre>

                            ) : (

                                <div className="anm-payload-data-list">

                                    {entries.length === 0 ? (

                                        <div className="anm-detail-value">
                                            No payload fields
                                        </div>

                                    ) : (

                                        entries.map(([key, value]) => (

                                            <Row
                                                key={key}
                                                className="anm-data-row align-items-center"
                                            >

                                                <Col xs={5}>
                                                    <span className="anm-data-label">
                                                        {key}
                                                    </span>
                                                </Col>

                                                <Col
                                                    xs={7}
                                                    className="text-end"
                                                >
                                                    <span className="anm-data-value">
                                                        {
                                                            Array.isArray(value)
                                                                ? value.join(", ")
                                                                : String(
                                                                    value == null
                                                                        ? "-"
                                                                        : value
                                                                )
                                                        }
                                                    </span>
                                                </Col>

                                            </Row>

                                        ))

                                    )}

                                </div>

                            )}

                        </Col>
                    </Row>

                    {/* Recommended Action */}
                    <Row className="anm-detail-group">
                        <Col md={12}>

                            <div className="anm-detail-label">
                                Recommended Action
                            </div>

                            <div className="anm-recommended-action">
                                {classification.recommendedAction}
                            </div>

                        </Col>
                    </Row>

                </div>

                {/* Footer */}
                <div className="anm-drawer-footer">

                    <button
                        type="button"
                        className="anm-btn anm-btn-outline"
                        onClick={() =>
                            onUpdateStatus("IN PROGRESS")
                        }
                    >
                        <i className="fas fa-spinner" />
                        Mark In Progress
                    </button>

                    <button
                        type="button"
                        className="anm-btn anm-btn-primary"
                        onClick={() =>
                            onUpdateStatus("RESOLVED")
                        }
                    >
                        <i className="fas fa-check" />
                        Mark Resolved
                    </button>

                </div>

            </div>
        </>
    );
}

export default NotificationDetailsDrawer;